import apiClient from "../../utils/apiclient";


export const notification=async(reqBody:{
   status: string;
},token:string)=>{
  return await apiClient.post('/activity/get-notifications',reqBody,{
     headers:{
        Authorization: `Bearer ${token}`
     }
  })

}
